export class CalamityNoteModel {
    clnId : string;
    clnCalamityId : string= null;
    clnRoleCodeId : string= null;
    clnNoteTypeId : string = null;
    clnFreeText : string = null;
    clnCreatedDate : Date ;
    clnCreatedBy : string = null;
    clnLastModifiedDate : Date ;
    clnLastModifiedBy : string ;
  }